import * as React from "react"

import { Svg } from "styleguide/components"
import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

const IconTwitter = ({
  title = "Twitter",
  viewBoxWidth = 32,
  viewBoxHeight = 32,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <path
      d="M16 32a16 16 0 110-32 16 16 0 010 32zm8-20.5c-.6.3-1.2.5-1.9.6.7-.5 1.2-1 1.5-1.9-.7.4-1.4.7-2.1.8a3.3 3.3 0 00-5.6 3A9.3 9.3 0 019 10.6a3.3 3.3 0 001 4.4c-.5 0-1-.2-1.5-.4 0 1.6 1.2 3 2.7 3.2a3.3 3.3 0 01-1.5 0 3.3 3.3 0 003 2.4A6.6 6.6 0 018 21.5a9.3 9.3 0 0014.4-8.3c.6-.4 1.2-1 1.6-1.7z"
      fill="#1EA1F2"
      fillRule="evenodd"
    />
  </Svg.Icon>
)

export default IconTwitter
